export default __webpack_public_path__ + "static/media/2Pblue_GW214.5f9133cf.png";